module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-rqf-page"
  }, [_c('div', {
    staticStyle: {
      "background-color": "#ccc",
      "height": "500px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77a15826"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/AutoOffer.vue
// module id = 115
// module chunks = 0